webpackJsonp([9],{

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return commonParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return opts; });
var commonParams = {
  // g_tk: 5381,
  g_tk: 1928093487,
  format: 'jsonp',
  inCharset: 'utf-8',
  outCharset: 'utf-8',
  notice: 0
};

var opts = {
  param: 'jsonpCallback'
};

/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export filterSinger */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SingerSong; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createSingerSong;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_song_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_base64__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_base64__);






// 处理 musicData.singer 数组，使其变为一个字符串
function filterSinger(singer) {
  var result = [];

  if (!singer) {
    return '';
  }

  singer.forEach(function (item) {
    result.push(item.name);
  });

  return result.join(' / ');
}

var SingerSong = function () {
  function SingerSong(_ref) {
    var id = _ref.id,
        mid = _ref.mid,
        singer = _ref.singer,
        name = _ref.name,
        album = _ref.album,
        duration = _ref.duration,
        img = _ref.img,
        url = _ref.url;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SingerSong);

    this.id = id;
    this.mid = mid;
    this.singer = singer;
    this.name = name;
    this.album = album;
    this.duration = duration;
    this.img = img;
    this.url = url;
  }
  // 获取歌词数据


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SingerSong, [{
    key: 'getLyric',
    value: function getLyric() {
      var _this = this;

      if (this.lyric) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.lyric);
      }

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_song_js__["a" /* getLyric */])(_this.mid).then(function (res) {
          if (res.retcode === 0) {
            _this.lyric = __WEBPACK_IMPORTED_MODULE_4_js_base64__["Base64"].decode(res.lyric);
            resolve(_this.lyric);
          } else {
            reject('no lyric');
          }
        });
      });
    }
  }]);

  return SingerSong;
}();

function createSingerSong(musicData) {
  return new SingerSong({
    id: musicData.songid,
    mid: musicData.songmid,
    singer: filterSinger(musicData.singer),
    name: musicData.songname,
    album: musicData.albumname,
    duration: musicData.interval,
    img: 'https://y.gtimg.cn/music/photo_new/T002R300x300M000' + musicData.albummid + '.jpg?max_age=2592000',
    // url: `http://10.151.0.22:9999/dl.stream.qqmusic.qq.com/C400${musicData.songmid}.m4a?fromtag=66`(可用)
    // url: `https://thirdparty.gtimg.com/${musicData.songid}.m4a?fromtag=38`(不可用)
    url: 'http://ws.stream.qqmusic.qq.com/' + musicData.songid + '.m4a?fromtag=46'
  });
}

/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = getStorage;
/* harmony export (immutable) */ __webpack_exports__["a"] = localSave;
/* harmony export (immutable) */ __webpack_exports__["b"] = localDel;
/* harmony export (immutable) */ __webpack_exports__["c"] = localClear;
/* harmony export (immutable) */ __webpack_exports__["h"] = getPlayStorage;
/* harmony export (immutable) */ __webpack_exports__["d"] = savePlay;
/* harmony export (immutable) */ __webpack_exports__["i"] = getFavorite;
/* harmony export (immutable) */ __webpack_exports__["e"] = saveFavorite;
/* harmony export (immutable) */ __webpack_exports__["f"] = delFavorite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_good_storage__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_good_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_good_storage__);


var SEARCH_KEY = '__search__';
// const SEARCH_MAX_LEN = 15

/**
 * 插入新元素到 arr[0] 并删除重复值，可控制数组最大长度
 * @param  {[type]} arr   要插入到哪个数组
 * @param  {[type]} val   要插入的值
 * @param  {fn} compareFn 比较函数
 * @param  {num} maxLen   数组最大长度
 * @return {[type]}           [description]
 */
function insertArr(arr, val, compareFn) {
  var maxLen = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 15;

  var index = arr.findIndex(compareFn);
  if (index === 0) {
    return;
  }
  if (index > 0) {
    arr.splice(index, 1);
  }
  // unshift() 方法可向数组的开头添加一个或更多元素，并返回新的长度。
  arr.unshift(val);
  if (maxLen && arr.length > maxLen) {
    // pop() 方法用于删除并返回数组的最后一个元素。
    arr.pop();
  }
}

function delArr(arr, compareFn) {
  var index = arr.findIndex(compareFn);
  if (index > -1) {
    arr.splice(index, 1);
  }
}

// 获取
function getStorage() {
  return __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.get(SEARCH_KEY, []);
}

// 增加
function localSave(query) {
  // 当前 localstorage 数组
  var searches = __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.get(SEARCH_KEY, []);

  insertArr(searches, query, function (item) {
    return item === query;
  }, 15);

  __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.set(SEARCH_KEY, searches);
  return searches;
}

// 删除
function localDel(query) {
  // 当前 localstorage 数组
  var searches = __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.get(SEARCH_KEY, []);

  delArr(searches, function (item) {
    return item === query;
  });

  __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.set(SEARCH_KEY, searches);
  return searches;
}

// 清空
function localClear(query) {
  __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.remove(SEARCH_KEY);
  return [];
}

// 最近播放 localstorage
var PLAY_KEY = '__play__';

// 获取
function getPlayStorage() {
  return __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.get(PLAY_KEY, []);
}

// 增加
function savePlay(song) {
  // 当前 localstorage 数组
  var songs = __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.get(PLAY_KEY, []);

  insertArr(songs, song, function (item) {
    return item.id === song.id;
  }, 50);

  __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.set(PLAY_KEY, songs);
  return songs;
}

// 最近播放 localstorage
var FAVORITE_KEY = '__favorite__';

// 获取
function getFavorite() {
  return __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.get(FAVORITE_KEY, []);
}

// 增加
function saveFavorite(song) {
  // 当前 localstorage 数组
  var songs = __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.get(FAVORITE_KEY, []);

  insertArr(songs, song, function (item) {
    return item.id === song.id;
  }, 50);

  __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.set(FAVORITE_KEY, songs);
  return songs;
}

// 删除
function delFavorite(song) {
  // 当前 localstorage 数组
  var songs = __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.get(FAVORITE_KEY, []);

  delArr(songs, function (item) {
    return item.id === song.id;
  });

  __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.set(FAVORITE_KEY, songs);
  return songs;
}

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_SINGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_PLAYING_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_FULL_SCREEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_PLAYLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_SEQUENCE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_CURRENT_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_SONGLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_RANKLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_SEARCHHISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_PLAYHISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_FAVORITE_LIST; });
// mutation 常量

var SET_SINGER = 'SET_SINGER';

var SET_PLAYING_STATE = 'SET_PLAYING_STATE';

var SET_FULL_SCREEN = 'SET_FULL_SCREEN';

var SET_PLAYLIST = 'SET_PLAYLIST';

var SET_SEQUENCE_LIST = 'SET_SEQUENCE_LIST';

var SET_MODE = 'SET_MODE';

var SET_CURRENT_INDEX = 'SET_CURRENT_INDEX';

var SET_SONGLIST = 'SET_SONGLIST';

var SET_RANKLIST = 'SET_RANKLIST';

var SET_SEARCHHISTORY = 'SET_SEARCHHISTORY';

var SET_PLAYHISTORY = 'SET_PLAYHISTORY';

var SET_FAVORITE_LIST = 'SET_FAVORITE_LIST';

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(494);


// import MyRecommend from '@/components/MyRecommend/MyRecommend'
// import MySinger from '@/components/MySinger/MySinger'
// import MyRank from '@/components/MyRank/MyRank'
// import MySearch from '@/components/MySearch/MySearch'
// import MySingerDetail from '@/components/MySingerDetail/MySingerDetail'
// import MySongListDetail from '@/components/MySongListDetail/MySongListDetail'
// import MyRankDetail from '@/components/MyRankDetail/MyRankDetail'
// import MyUser from '@/components/MyUser/MyUser'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

// 路由懒加载
var MyRecommend = function MyRecommend(resolve) {
  __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 541)).then(function (module) {
    resolve(module);
  });
};
var MySinger = function MySinger(resolve) {
  __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 544)).then(function (module) {
    resolve(module);
  });
};
var MyRank = function MyRank(resolve) {
  __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 540)).then(function (module) {
    resolve(module);
  });
};
var MySearch = function MySearch(resolve) {
  __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 542)).then(function (module) {
    resolve(module);
  });
};
var MySingerDetail = function MySingerDetail(resolve) {
  __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 543)).then(function (module) {
    resolve(module);
  });
};
var MySongListDetail = function MySongListDetail(resolve) {
  __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 545)).then(function (module) {
    resolve(module);
  });
};
var MyRankDetail = function MyRankDetail(resolve) {
  __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 539)).then(function (module) {
    resolve(module);
  });
};
var MyUser = function MyUser(resolve) {
  __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 546)).then(function (module) {
    resolve(module);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/recommend'
  }, {
    path: '/user',
    name: 'user',
    component: MyUser
  }, {
    path: '/recommend',
    name: 'recommend',
    component: MyRecommend,
    children: [{
      path: ':id',
      name: 'songlistdetail',
      component: MySongListDetail
    }]
  }, {
    path: '/singer',
    name: 'singer',
    component: MySinger,
    children: [{
      path: ':id',
      name: 'singerdetail',
      component: MySingerDetail
    }]
  }, {
    path: '/rank',
    name: 'rank',
    component: MyRank,
    children: [{
      path: ':id',
      name: 'rankdetail',
      component: MyRankDetail
    }]
  }, {
    path: '/search',
    name: 'search',
    component: MySearch,
    children: [{
      path: ':id',
      component: MySingerDetail
    }]
  }]
}));

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters_js__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger__);
// 组装模块并导出 store 的地方







 // Vuex 自带一个日志插件用于一般的调试

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_4__actions_js__,
  getters: __WEBPACK_IMPORTED_MODULE_5__getters_js__,
  strict: debug,
  plugins: debug ? [__WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger___default()()] : []
}));

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 177:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(458)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(491),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bcb11f9e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = jsonp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonp__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsonp__);



function param(data) {
  var url = '';
  for (var i in data) {
    var value = data[i] !== undefined ? data[i] : '';
    url += '&' + i + '=' + encodeURIComponent(value);
  }
  // 删掉第一个 &
  return url ? url.substring(1) : '';
}

function jsonp(url, data, opts) {
  url += (url.indexOf('?') === -1 ? '?' : '&') + param(data);

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_jsonp___default()(url, opts, function (err, data) {
      if (!err) {
        resolve(data);
      } else {
        reject(err);
      }
    });
  });
}

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(457)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(490),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7a30799c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(447)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(480),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4dbd2ccc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getHotKey;
/* harmony export (immutable) */ __webpack_exports__["a"] = search;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_jsonp__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_common_query_js__ = __webpack_require__(119);




/**
 * jsonp 抓取热门搜索数据
 * 接口：https://c.y.qq.com/splcloud/fcgi-bin/gethotkey.fcg
 * 提供方：https://m.y.qq.com/#search
 */
function getHotKey() {
  var url = 'https://c.y.qq.com/splcloud/fcgi-bin/gethotkey.fcg';
  var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__api_common_query_js__["a" /* commonParams */], {
    uin: 0,
    format: 'json',
    platform: 'h5',
    needNewCode: 1
  });
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js_jsonp__["a" /* default */])(url, data, __WEBPACK_IMPORTED_MODULE_2__api_common_query_js__["b" /* opts */]);
}

/**
 * jsonp 抓取搜索检索数据
 * 接口：https://c.y.qq.com/soso/fcgi-bin/search_for_qq_cp
 * 提供方：https://m.y.qq.com/#search
 */
function search(query, page, perpage, zhida) {
  var url = 'https://c.y.qq.com/soso/fcgi-bin/search_for_qq_cp';
  var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__api_common_query_js__["a" /* commonParams */], {
    w: query,
    p: page,
    n: perpage,
    perpage: perpage,
    zhidaqu: 1,
    catZhida: zhida ? 1 : 0,
    t: 0,
    flag: 1,
    ie: 'utf-8',
    sem: 1,
    aggr: 0,
    uin: 0,
    platform: 'h5',
    uid: 0,
    needNewCode: 1,
    remoteplace: 'txt.mqq.all'
  });
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js_jsonp__["a" /* default */])(url, data, __WEBPACK_IMPORTED_MODULE_2__api_common_query_js__["b" /* opts */]);
}

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Singer; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createSinger;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

// 歌手信息类

var Singer =
// 传入一个对象
function Singer(_ref) {
  var id = _ref.id,
      name = _ref.name;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Singer);

  this.id = id;
  this.name = name;
  this.avatar = "https://y.gtimg.cn/music/photo_new/T001R300x300M000" + id + ".jpg?max_age=2592000";
};

// 工厂方式创建类实例
function createSinger(singer) {
  return new Singer({
    id: singer.Fsinger_mid,
    name: singer.Fsinger_name
  });
}

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(456)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(489),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-76550d64",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(454)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(487),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-713fa8b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(452)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(485),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f22ee8c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(460)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(493),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fd29582c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(449)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(482),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6cad8afa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(450)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(483),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6dfe1a3a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLyric;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_common_query_js__ = __webpack_require__(119);





/**
 * axios 抓取歌词数据
 * 接口：https://c.y.qq.com/lyric/fcgi-bin/fcg_query_lyric_new.fcg
 * 原始地址：https://y.qq.com/portal/player.html
 * 接口提供方使用了 referer:https://y.qq.com/portal/player.html
 * axios 结合 node.js 代理后端请求
 */
function getLyric(mid) {
  var url = '/api/getLyric';
  var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_3__api_common_query_js__["a" /* commonParams */], {
    songmid: mid,
    // g_tk: 67232076,
    format: 'json',
    pcachetime: +new Date(),
    platform: 'yqq',
    // categoryId: 10000000,
    hostUin: 0,
    needNewCode: 0
  });
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url, {
    params: data
  }).then(function (res) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
  }).catch(function (err) {
    console.log(err);
  });
}

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_scss_index_scss__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_scss_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_scss_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fastclick__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_lazyload__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_lazyload__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



 // vue-router
 // vuex



// 移动端调试工具，在移动端输出日志
/* eslint-disable no-unused-vars */
// import vConsole from 'vconsole'
// console.log('Hello world')

// 消除 click 移动浏览器300ms延迟

__WEBPACK_IMPORTED_MODULE_6_fastclick___default.a.attach(document.body);

// 图片懒加载

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_lazyload___default.a, {
  loading: __webpack_require__(177)
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a
    // render: h => h(App)
  } });

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectPlay", function() { return selectPlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "randomPlay", function() { return randomPlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "insertSong", function() { return insertSong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteSong", function() { return deleteSong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveHistory", function() { return saveHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delHistory", function() { return delHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearHistory", function() { return clearHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteSongList", function() { return deleteSongList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveplayHistory", function() { return saveplayHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "savefavoriteList", function() { return savefavoriteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delfavoriteList", function() { return delfavoriteList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations_type_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_myutils_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_store_js__ = __webpack_require__(121);
// 根级别的 action
// 封装复杂的 mutations





function findIndex(list, song) {
  return list.findIndex(function (item) {
    return item.id === song.id;
  });
}

// 选择歌曲播放
var selectPlay = function selectPlay(_ref, _ref2) {
  var commit = _ref.commit,
      state = _ref.state;
  var list = _ref2.list,
      index = _ref2.index;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["a" /* SET_PLAYING_STATE */], true);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["b" /* SET_FULL_SCREEN */], true);
  // 避免随机播放时，点击歌单，播放歌曲乱序
  if (state.mode === 2) {
    var randomList = __WEBPACK_IMPORTED_MODULE_1__common_js_myutils_js__["b" /* myArray */].shuffle(list);
    commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["c" /* SET_PLAYLIST */], randomList);
    index = findIndex(randomList, list[index]);
  } else {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["c" /* SET_PLAYLIST */], list);
  }
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["d" /* SET_SEQUENCE_LIST */], list);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["e" /* SET_CURRENT_INDEX */], index);
};

// 随机播放全部按钮
var randomPlay = function randomPlay(_ref3, _ref4) {
  var commit = _ref3.commit;
  var list = _ref4.list;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["f" /* SET_MODE */], 2);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["a" /* SET_PLAYING_STATE */], true);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["b" /* SET_FULL_SCREEN */], true);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["c" /* SET_PLAYLIST */], __WEBPACK_IMPORTED_MODULE_1__common_js_myutils_js__["b" /* myArray */].shuffle(list));
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["d" /* SET_SEQUENCE_LIST */], list);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["e" /* SET_CURRENT_INDEX */], 0);
};

// 新增歌曲到播放列表
var insertSong = function insertSong(_ref5, song) {
  var commit = _ref5.commit,
      state = _ref5.state;

  var playlist = state.playlist.slice(0);
  var sequenceList = state.sequenceList.slice(0);
  var currentIndex = state.currentIndex;

  // 记录当前歌曲
  var currentSong = playlist[currentIndex];

  // 查询待添加的歌曲是否已在播放列表中
  var fpIndex = findIndex(playlist, song);

  // 插入到当前索引
  currentIndex++;
  playlist.splice(currentIndex, 0, song);

  // 如果待添加的歌曲已在播放列表中，删除原有歌曲
  if (fpIndex > -1) {
    if (currentIndex > fpIndex) {
      playlist.splice(fpIndex, 1);
      currentIndex--;
    } else {
      playlist.splice(fpIndex + 1, 1);
    }
  }

  // 插入到 sequenceList 中的位置
  var currentSIndex = findIndex(sequenceList, currentSong) + 1;

  // 查询待添加的歌曲是否已在 sequenceList 列表中
  var fsIndex = findIndex(sequenceList, song);

  // 插入到当前索引
  sequenceList.splice(currentSIndex, 0, song);

  // 如果待添加的歌曲已在播放列表中，删除原有歌曲
  if (fsIndex > -1) {
    if (currentSIndex > fsIndex) {
      sequenceList.splice(fsIndex, 1);
    } else {
      sequenceList.splice(fsIndex + 1, 1);
    }
  }

  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["c" /* SET_PLAYLIST */], playlist);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["d" /* SET_SEQUENCE_LIST */], sequenceList);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["e" /* SET_CURRENT_INDEX */], currentIndex);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["a" /* SET_PLAYING_STATE */], true);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["b" /* SET_FULL_SCREEN */], true);
};

// 从播放列表中删除歌曲
var deleteSong = function deleteSong(_ref6, song) {
  var commit = _ref6.commit,
      state = _ref6.state;

  var playlist = state.playlist.slice(0);
  var sequenceList = state.sequenceList.slice(0);
  var currentIndex = state.currentIndex;

  // 查询待删除的歌曲
  var pIndex = findIndex(playlist, song);
  playlist.splice(pIndex, 1);

  // sequenceList 中的位置
  var sIndex = findIndex(sequenceList, song);
  sequenceList.splice(sIndex, 1);

  if (currentIndex > pIndex || currentIndex === playlist.length) {
    currentIndex--;
  }

  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["c" /* SET_PLAYLIST */], playlist);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["d" /* SET_SEQUENCE_LIST */], sequenceList);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["e" /* SET_CURRENT_INDEX */], currentIndex);

  var playingState = playlist.length > 0;
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["a" /* SET_PLAYING_STATE */], playingState);
};

/**
 * 保存搜索历史
 * @param  {[type]} query          搜索关键词
 */
var saveHistory = function saveHistory(_ref7, query) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["g" /* SET_SEARCHHISTORY */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js_store_js__["a" /* localSave */])(query));
};

/**
 * 删除单个搜索历史
 * @param  {[type]} query          搜索关键词
 */
var delHistory = function delHistory(_ref8, query) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["g" /* SET_SEARCHHISTORY */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js_store_js__["b" /* localDel */])(query));
};

/**
 * 删除全部搜索历史
 * @param  {[type]} query          搜索关键词
 */
var clearHistory = function clearHistory(_ref9) {
  var commit = _ref9.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["g" /* SET_SEARCHHISTORY */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js_store_js__["c" /* localClear */])());
};

// 清空播放列表
var deleteSongList = function deleteSongList(_ref10, song) {
  var commit = _ref10.commit,
      state = _ref10.state;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["c" /* SET_PLAYLIST */], []);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["d" /* SET_SEQUENCE_LIST */], []);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["e" /* SET_CURRENT_INDEX */], -1);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["a" /* SET_PLAYING_STATE */], false);
};

// 把当前歌曲写进 vuex 最近播放 playHistory 中
var saveplayHistory = function saveplayHistory(_ref11, song) {
  var commit = _ref11.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["h" /* SET_PLAYHISTORY */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js_store_js__["d" /* savePlay */])(song));
};

// 我的收藏
var savefavoriteList = function savefavoriteList(_ref12, song) {
  var commit = _ref12.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["i" /* SET_FAVORITE_LIST */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js_store_js__["e" /* saveFavorite */])(song));
};

var delfavoriteList = function delfavoriteList(_ref13, song) {
  var commit = _ref13.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutations_type_js__["i" /* SET_FAVORITE_LIST */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js_store_js__["f" /* delFavorite */])(song));
};

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "singer", function() { return singer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "playing", function() { return playing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fullScreen", function() { return fullScreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "playlist", function() { return playlist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sequenceList", function() { return sequenceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mode", function() { return mode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentIndex", function() { return currentIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentSong", function() { return currentSong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "songlist", function() { return songlist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rankList", function() { return rankList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchHistory", function() { return searchHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "playHistory", function() { return playHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "favoriteList", function() { return favoriteList; });
// 映射及计算

var singer = function singer(state) {
  return state.singer;
};

var playing = function playing(state) {
  return state.playing;
};

var fullScreen = function fullScreen(state) {
  return state.fullScreen;
};

var playlist = function playlist(state) {
  return state.playlist;
};

var sequenceList = function sequenceList(state) {
  return state.sequenceList;
};

var mode = function mode(state) {
  return state.mode;
};

// 当前播放的歌曲的索引
var currentIndex = function currentIndex(state) {
  return state.currentIndex;
};

// 当前播放的歌曲
var currentSong = function currentSong(state) {
  return state.playlist[state.currentIndex] || {};
};

var songlist = function songlist(state) {
  return state.songlist;
};

var rankList = function rankList(state) {
  return state.rankList;
};

var searchHistory = function searchHistory(state) {
  return state.searchHistory;
};

var playHistory = function playHistory(state) {
  return state.playHistory;
};

var favoriteList = function favoriteList(state) {
  return state.favoriteList;
};

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_type_js__ = __webpack_require__(122);


var _mutations;

// 根级别的 mutation



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type_js__["j" /* SET_SINGER */], function (state, singer) {
  state.singer = singer;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type_js__["a" /* SET_PLAYING_STATE */], function (state, flag) {
  state.playing = flag;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type_js__["b" /* SET_FULL_SCREEN */], function (state, flag) {
  state.fullScreen = flag;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type_js__["c" /* SET_PLAYLIST */], function (state, list) {
  state.playlist = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type_js__["d" /* SET_SEQUENCE_LIST */], function (state, list) {
  state.sequenceList = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type_js__["f" /* SET_MODE */], function (state, mode) {
  state.mode = mode;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type_js__["e" /* SET_CURRENT_INDEX */], function (state, index) {
  state.currentIndex = index;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type_js__["k" /* SET_SONGLIST */], function (state, songlist) {
  state.songlist = songlist;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type_js__["l" /* SET_RANKLIST */], function (state, rankList) {
  state.rankList = rankList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type_js__["g" /* SET_SEARCHHISTORY */], function (state, searchHistory) {
  state.searchHistory = searchHistory;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type_js__["h" /* SET_PLAYHISTORY */], function (state, playHistory) {
  state.playHistory = playHistory;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type_js__["i" /* SET_FAVORITE_LIST */], function (state, list) {
  state.favoriteList = list;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_store_js__ = __webpack_require__(121);
/**
 * 单一状态树
 * vuex 操作顺序：state.js -> mutations-type.js -> mutations.js -> getters.js
 */


var playMode = {
  sequence: 0, // 顺序播放
  loop: 1, // 单曲循环
  random: 2 // 随机播放
};

var state = {
  // 歌手信息
  singer: {},
  // 播放器播放状态
  playing: false,
  // 播放器展开状态
  fullScreen: false,
  // 播放歌曲列表
  playlist: [],
  // 顺序播放列表
  sequenceList: [],
  // 播放模式
  mode: playMode.sequence,
  // 当前播放歌曲索引
  currentIndex: -1,
  // 推荐页歌单
  songlist: {},
  // 歌曲排行数据
  rankList: {},
  // 搜索结果
  searchHistory: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js_store_js__["g" /* getStorage */])(),
  // 播放历史（最近播放）
  playHistory: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js_store_js__["h" /* getPlayStorage */])(),
  // 我的收藏
  favoriteList: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js_store_js__["i" /* getFavorite */])()
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MyHeader_MyHeader__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MyHeader_MyHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_MyHeader_MyHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MyTab_MyTab__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MyTab_MyTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_MyTab_MyTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MyPlayer_MyPlayer__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MyPlayer_MyPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MyPlayer_MyPlayer__);
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MyHeader: __WEBPACK_IMPORTED_MODULE_0__components_MyHeader_MyHeader___default.a,
    MyTab: __WEBPACK_IMPORTED_MODULE_1__components_MyTab_MyTab___default.a,
    MyPlayer: __WEBPACK_IMPORTED_MODULE_2__components_MyPlayer_MyPlayer___default.a
  }
});

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_MySearchBox_MySearchBox__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_MySearchBox_MySearchBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_base_MySearchBox_MySearchBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_MyScroll_MyScroll__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_MyScroll_MyScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_base_MyScroll_MyScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_MySwitches_MySwitches__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_MySwitches_MySwitches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_base_MySwitches_MySwitches__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_MySongList_MySongList__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_MySongList_MySongList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_base_MySongList_MySongList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_MyTopTip_MyTopTip__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_MyTopTip_MyTopTip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_base_MyTopTip_MyTopTip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_base_MySearchList_MySearchList__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_base_MySearchList_MySearchList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_base_MySearchList_MySearchList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MySuggestList_MySuggestList__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MySuggestList_MySuggestList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_MySuggestList_MySuggestList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_js_SingerSongClass_js__ = __webpack_require__(120);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MySearchBox: __WEBPACK_IMPORTED_MODULE_1__components_base_MySearchBox_MySearchBox___default.a,
    MySuggestList: __WEBPACK_IMPORTED_MODULE_7__components_MySuggestList_MySuggestList___default.a,
    MySearchList: __WEBPACK_IMPORTED_MODULE_6__components_base_MySearchList_MySearchList___default.a,
    MyScroll: __WEBPACK_IMPORTED_MODULE_2__components_base_MyScroll_MyScroll___default.a,
    MySwitches: __WEBPACK_IMPORTED_MODULE_3__components_base_MySwitches_MySwitches___default.a,
    MySongList: __WEBPACK_IMPORTED_MODULE_4__components_base_MySongList_MySongList___default.a,
    MyTopTip: __WEBPACK_IMPORTED_MODULE_5__components_base_MyTopTip_MyTopTip___default.a
  },
  data: function data() {
    return {
      showFlag: false,
      // 搜索词
      query: '',
      // 不搜索歌手
      zhida: false,
      // 切换开关文案
      switches: [{ name: '最近播放' }, { name: '搜索历史' }],
      // 当前切换开关
      currentIndex: 0,
      refreshDelay: 100
    };
  },

  props: {},
  watch: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(['saveHistory', 'delHistory', 'insertSong']), {
    // 保存搜索结果历史到 vuex 和 localstorage 中
    savaHis: function savaHis() {
      this.saveHistory(this.query);
      this.$refs.topTipRef.show();
    },
    deleteHis: function deleteHis(item) {
      this.delHistory(item);
    },
    show: function show() {
      var _this = this;

      this.showFlag = true;
      setTimeout(function () {
        if (_this.currentIndex === 0) {
          _this.$refs.songListRef.refresh();
        } else {
          _this.$refs.searchListRef.refresh();
        }
      }, 20);
    },
    hide: function hide() {
      this.showFlag = false;
    },

    // 当检索值改变时
    onQueryChange: function onQueryChange(query) {
      this.query = query;
    },
    addQuery: function addQuery(k) {
      this.$refs.searchBoxRef.getQuery(k);
    },

    // 滚动前触发事件
    blurInput: function blurInput() {
      this.$refs.searchBoxRef.blur();
    },
    switchItem: function switchItem(index) {
      this.currentIndex = index;
    },
    selectSong: function selectSong(item, index) {
      if (index !== 0) {
        this.insertSong(new __WEBPACK_IMPORTED_MODULE_9__common_js_SingerSongClass_js__["a" /* SingerSong */](item));
      }

      this.$refs.topTipRef.show();
    }
  }),
  // 过滤器设计目的就是用于简单的文本转换
  filters: {},
  // 若要实现更复杂的数据变换，你应该使用计算属性
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(['searchHistory', 'playHistory'])),
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {}
});

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_js_myutils_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_MyProgressBar_MyProgressBar__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_MyProgressBar_MyProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_base_MyProgressBar_MyProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_MyProgressCircle_MyProgressCircle__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_MyProgressCircle_MyProgressCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_base_MyProgressCircle_MyProgressCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MyPlaylist_MyPlaylist__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MyPlaylist_MyPlaylist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_MyPlaylist_MyPlaylist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_base_MyScroll_MyScroll__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_base_MyScroll_MyScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_base_MyScroll_MyScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lyric_parser__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lyric_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lyric_parser__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








 // QQ音乐 歌词解析 https://github.com/ustbhuangyi/lyric-parser

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MyProgressBar: __WEBPACK_IMPORTED_MODULE_4__components_base_MyProgressBar_MyProgressBar___default.a,
    MyProgressCircle: __WEBPACK_IMPORTED_MODULE_5__components_base_MyProgressCircle_MyProgressCircle___default.a,
    MyScroll: __WEBPACK_IMPORTED_MODULE_7__components_base_MyScroll_MyScroll___default.a,
    MyPlaylist: __WEBPACK_IMPORTED_MODULE_6__components_MyPlaylist_MyPlaylist___default.a
  },
  data: function data() {
    return {
      // 标志位。歌曲已缓存好，可以播放了
      songCanplay: false,
      // 当前播放时间
      currentTime: 0,
      // 当前的歌词
      currentLyric: null,
      // 当前的歌词在第几行
      currentLyricLine: 0,
      // 当前在哪个分页
      currentDot: 'cd',
      // cd页小段歌词
      playingLyric: '无歌词数据',
      // 是否显示播放列表
      showList: false
    };
  },

  props: {},
  watch: {
    // 监控当前歌曲
    currentSong: function currentSong(newVal, oldVal) {
      var _this = this;

      // console.log(this.currentSong)

      // 播放列表没有歌曲就退出
      if (!newVal.id) {
        return;
      }

      if (newVal.id === oldVal.id) {
        return;
      }

      // 切歌时，停止当前歌词
      if (this.currentLyric) {
        this.currentLyric.stop();
      }

      // DOM 更新了
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this.$refs.audioRef.play();
        _this._getLyric();
      }, 1000);
    },

    // 播放 or 暂停
    playing: function playing(newVal) {
      var audio = this.$refs.audioRef;

      this.$nextTick(function () {
        newVal ? audio.play() : audio.pause();
      });
    }
  },
  filters: {
    format: function format(value) {
      if (!value) return '';
      return __WEBPACK_IMPORTED_MODULE_3__common_js_myutils_js__["a" /* myTime */].format(value);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])({
    setfullScreen: 'SET_FULL_SCREEN',
    setPlayingState: 'SET_PLAYING_STATE',
    setCurrentIndex: 'SET_CURRENT_INDEX',
    setMode: 'SET_MODE',
    setPlayList: 'SET_PLAYLIST'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['saveplayHistory', 'savefavoriteList', 'delfavoriteList']), {
    toggleFavoriteCls: function toggleFavoriteCls(song) {
      if (this._isFavorite(song)) {
        this.delfavoriteList(song);
      } else {
        this.savefavoriteList(song);
      }
    },
    getFavoriteCls: function getFavoriteCls(song) {
      if (this._isFavorite(song)) {
        return 'icon-favorite';
      } else {
        return 'icon-not-favorite';
      }
    },
    _isFavorite: function _isFavorite(song) {
      var index = this.favoriteList.findIndex(function (item) {
        return song.id === item.id;
      });

      return index > -1;
    },

    // 显示播放列表
    showPlaylist: function showPlaylist() {
      this.$refs.playlistRef.show();
    },

    // props down，当进度改变了
    percentChange: function percentChange(newPercent) {
      var currentTime = this.currentSong.duration * newPercent;
      this.$refs.audioRef.currentTime = currentTime;

      // 进度改变后自动播放
      if (!this.playing) {
        this.togglePlaying();
      }

      if (this.currentLyric) {
        this.currentLyric.seek(currentTime * 1000);
      }
    },

    // 改变播放模式，实质是修改 playlist
    changeMode: function changeMode() {
      var _this2 = this;

      var mode = (this.mode + 1) % 3;
      this.setMode(mode);

      var newList = null;
      if (mode === 2) {
        // 随机播放
        newList = __WEBPACK_IMPORTED_MODULE_3__common_js_myutils_js__["b" /* myArray */].shuffle(this.sequenceList);
      } else {
        // 顺序播放、单曲循环
        newList = this.sequenceList;
      }

      // 调整当前歌曲的索引
      var index = newList.findIndex(function (item) {
        return item.id === _this2.currentSong.id;
      });
      this.setCurrentIndex(index);
      this.setPlayList(newList);
    },

    // 最小化播放器
    back: function back() {
      this.setfullScreen(false);
    },

    // 最大化播放器
    open: function open() {
      this.setfullScreen(true);
    },

    // audio API canplay 当浏览器可以播放音频/视频时
    canplay: function canplay() {
      this.songCanplay = true;
      // 把当前歌曲写进 vuex 最近播放 playHistory 中
      this.saveplayHistory(this.currentSong);
    },

    // audio API error 当在音频/视频加载期间发生错误时
    error: function error() {
      this.songCanplay = true;
    },

    // audio API timeupdate  当目前的播放位置已更改时
    // HTML5 Audio/Video 属性 currentTime  设置或返回音频/视频中的当前播放位置（以秒计）
    timeupdate: function timeupdate(e) {
      this.currentTime = e.target.currentTime;
    },

    // audio API ended  当前歌曲播放完毕
    ended: function ended() {
      if (this.mode === 1) {
        // 单曲循环模式
        this.loopSong();
      } else {
        this.nextSong();
      }
    },

    // 播放按钮
    togglePlaying: function togglePlaying() {
      if (!this.songCanplay) {
        return;
      }

      this.setPlayingState(!this.playing);

      // 暂停时，歌词也暂停
      if (this.currentLyric) {
        this.currentLyric.togglePlay();
      }
    },

    // 上一首
    prevSong: function prevSong() {
      if (!this.songCanplay) {
        return;
      }

      var index = this.currentIndex - 1;
      if (index === -1) {
        index = this.playlist.length - 1;
      }
      this.setCurrentIndex(index);
      if (!this.playing) {
        this.togglePlaying();
        this.songCanplay = false;
      }
    },

    // 下一首
    nextSong: function nextSong() {
      if (!this.songCanplay) {
        return;
      }

      // 如果播放列表只要一条数据
      if (this.playlist.length === 1) {
        this.loopSong();
      } else {
        var index = this.currentIndex + 1;
        if (index === this.playlist.length) {
          index = 0;
        }
        this.setCurrentIndex(index);
        if (!this.playing) {
          this.togglePlaying();
        }
      }

      this.songCanplay = false;
    },

    // 单曲循环
    loopSong: function loopSong() {
      this.$refs.audioRef.currentTime = 0;
      this.$refs.audioRef.play();

      // 单曲循环时，歌词也单曲循环
      if (this.currentLyric) {
        this.currentLyric.seek(0);
      }
    },

    // 中部 cd 唱片，js 动画钩子
    enter: function enter(el, done) {
      var _getPosAndScale = this._getPosAndScale(),
          x = _getPosAndScale.x,
          y = _getPosAndScale.y,
          scale = _getPosAndScale.scale;

      var animation = {
        0: {
          transform: 'translate3d(' + x + 'px, ' + y + 'px, 0) scale(' + scale + ')'
        },
        60: {
          transform: 'translate3d(0, 0, 0) scale(1.1)'
        },
        100: {
          transform: 'translate3d(0, 0, 0) scale(1)'
        }
      };

      __WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation___default.a.registerAnimation({
        name: 'move',
        animation: animation,
        presets: {
          duration: 400,
          easing: 'linear',
          delay: 100
        }
      });

      // then run it
      __WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation___default.a.runAnimation(this.$refs.cdRef, 'move', done);
    },
    afterEnter: function afterEnter() {
      __WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation___default.a.unregisterAnimation('move');
      this.$refs.cdRef.style.animation = '';
    },
    leave: function leave(el, done) {
      var _getPosAndScale2 = this._getPosAndScale(),
          x = _getPosAndScale2.x,
          y = _getPosAndScale2.y,
          scale = _getPosAndScale2.scale;

      this.$refs.cdRef.style.transition = 'all 0.4s ease';
      this.$refs.cdRef.style['transform'] = 'translate3d(' + x + 'px, ' + y + 'px, 0) scale(' + scale + ')';
      this.$refs.cdRef.style['webkitTransform'] = 'translate3d(' + x + 'px, ' + y + 'px, 0) scale(' + scale + ')';

      this.$refs.cdRef.addEventListener('transitionend', done);
    },
    afterLeave: function afterLeave() {
      this.$refs.cdRef.style['transform'] = '';
      this.$refs.cdRef.style['webkitTransform'] = '';
      this.$refs.cdRef.style.transition = '';
    },
    _getPosAndScale: function _getPosAndScale() {
      var targetWidth = 40;
      var paddingLeft = 40;
      var paddingBottom = 30;
      var paddingTop = 80;
      var width = window.innerWidth * 0.8;
      var scale = targetWidth / width;
      var x = -(window.innerWidth / 2 - paddingLeft);
      var y = window.innerHeight - paddingTop - width / 2 - paddingBottom;
      return { x: x, y: y, scale: scale };
    },

    // 歌词处理
    _getLyric: function _getLyric() {
      var _this3 = this;

      this.currentSong.getLyric().then(function (lyric) {
        if (_this3.currentSong.lyric !== lyric) {
          return;
        }

        _this3.currentLyric = new __WEBPACK_IMPORTED_MODULE_8_lyric_parser___default.a(lyric, _this3.handleLyric);
        if (_this3.playing) {
          _this3.currentLyric.play();
        }
      }).catch(function () {
        // 获取歌词失败时
        _this3.currentLyric = null;
        _this3.playingLyric = '无歌词数据';
        _this3.currentLyricLine = 0;
      });
    },

    // new Lyric 回调函数
    handleLyric: function handleLyric(_ref) {
      var lineNum = _ref.lineNum,
          txt = _ref.txt;

      // this hanlder called when lineNum change
      this.currentLyricLine = lineNum;

      // 歌词在中间
      if (lineNum > 5) {
        var el = this.$refs.lyricLine[lineNum - 5];
        this.$refs.lyricList.scrollToElement(el, 1000);
      } else {
        this.$refs.lyricList.scrollTo(0, 0, 1000);
      }

      // 当前歌词
      this.playingLyric = txt;
    },

    // 滑动翻页
    middleTouchstart: function middleTouchstart(e) {
      this.touch.init = true;
      // 开始滑动的位置
      this.touch.startX = e.touches[0].pageX;
      this.touch.startY = e.touches[0].pageY;
    },
    middleTouchmove: function middleTouchmove(e) {
      if (!this.touch.init) {
        return;
      }

      // 滑动的差值
      var deltaX = e.touches[0].pageX - this.touch.startX;
      var deltaY = e.touches[0].pageY - this.touch.startY;

      // 纵向滚动 return
      if (Math.abs(deltaX) < Math.abs(deltaY)) {
        return;
      }

      var left = this.currentDot === 'cd' ? 0 : -window.innerWidth;
      // 左滑的距离
      var offsetWidth = Math.min(0, Math.max(-window.innerWidth, left + deltaX));
      this.touch.percent = Math.abs(offsetWidth / window.innerWidth);
      // console.log(this.touch.percent)

      this.$refs.lyricList.$el.style['webkitTransform'] = 'translate3d(' + offsetWidth + 'px, 0, 0)';
      this.$refs.lyricList.$el.style['transform'] = 'translate3d(' + offsetWidth + 'px, 0, 0)';
      // 过渡效果坚持 0ms
      this.$refs.lyricList.$el.style['webkitTransition-duration'] = 0;
      this.$refs.lyricList.$el.style['transition-duration'] = 0;
      // 背景模糊
      this.$refs.middleRef.style.opacity = 1 - this.touch.percent;
      this.$refs.middleRef.style['webkitTransition-duration'] = 0;
      this.$refs.middleRef.style['transition-duration'] = 0;
    },
    middleTouchend: function middleTouchend() {
      var offsetWidth = null;
      var opacity = null;

      if (this.currentDot === 'cd') {
        // 左滑
        if (this.touch.percent > 0.1) {
          offsetWidth = -window.innerWidth;
          this.currentDot = 'lyric';
          opacity = 0;
        } else {
          offsetWidth = 0;
          opacity = 1;
        }
      } else {
        // 右滑
        if (this.touch.percent < 0.9) {
          offsetWidth = 0;
          this.currentDot = 'cd';
          opacity = 1;
        } else {
          offsetWidth = -window.innerWidth;
          opacity = 0;
        }
      }

      this.$refs.lyricList.$el.style['webkitTransform'] = 'translate3d(' + offsetWidth + 'px, 0, 0)';
      this.$refs.lyricList.$el.style['transform'] = 'translate3d(' + offsetWidth + 'px, 0, 0)';
      // 过渡效果坚持 300ms
      this.$refs.lyricList.$el.style['webkitTransition-duration'] = '300ms';
      this.$refs.lyricList.$el.style['transition-duration'] = '300ms';
      // 背景模糊
      this.$refs.middleRef.style.opacity = opacity;
      this.$refs.middleRef.style['webkitTransition-duration'] = '300ms';
      this.$refs.middleRef.style['transition-duration'] = '300ms';
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['fullScreen', 'playlist', 'currentSong', 'playing', 'currentIndex', 'currentSong', 'mode', 'sequenceList', 'favoriteList']), {
    // props down，播放进度
    percent: function percent() {
      return this.currentTime / this.currentSong.duration;
    },

    // 播放模式对应图标字体
    iconMode: function iconMode() {
      var cls = '';
      if (this.mode === 0) {
        cls = 'icon-sequence';
      } else if (this.mode === 1) {
        cls = 'icon-loop';
      } else if (this.mode === 2) {
        cls = 'icon-random';
      } else {
        cls = '';
      }
      return cls;
    }
  }),
  created: function created() {
    // 维护一个滑动状态对象
    this.touch = {};
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {}
});

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_MyScroll_MyScroll__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_MyScroll_MyScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_base_MyScroll_MyScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_MyConfirm_MyConfirm__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_MyConfirm_MyConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_base_MyConfirm_MyConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MyAddSong_MyAddSong__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MyAddSong_MyAddSong___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_MyAddSong_MyAddSong__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_js_myutils_js__ = __webpack_require__(62);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MyScroll: __WEBPACK_IMPORTED_MODULE_1__components_base_MyScroll_MyScroll___default.a,
    MyConfirm: __WEBPACK_IMPORTED_MODULE_2__components_base_MyConfirm_MyConfirm___default.a,
    MyAddSong: __WEBPACK_IMPORTED_MODULE_3__components_MyAddSong_MyAddSong___default.a
  },
  data: function data() {
    return {
      showFlag: false,
      refreshDelay: 100
    };
  },

  props: {},
  watch: {
    // 切歌后滚动至第一个
    currentSong: function currentSong(newVal, oldVal) {
      if (!newVal.id || !oldVal.id) {
        return;
      }

      if (!this.showFlag || newVal.id === oldVal.id) {
        return;
      }

      this.scrollToCurrent(newVal);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])({
    setMode: 'SET_MODE',
    setCurrentIndex: 'SET_CURRENT_INDEX',
    setPlayingState: 'SET_PLAYING_STATE',
    setPlayList: 'SET_PLAYLIST'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['deleteSong', 'deleteSongList', 'savefavoriteList', 'delfavoriteList']), {
    toggleFavoriteCls: function toggleFavoriteCls(song) {
      if (this._isFavorite(song)) {
        this.delfavoriteList(song);
      } else {
        this.savefavoriteList(song);
      }
    },
    getFavoriteCls: function getFavoriteCls(song) {
      if (this._isFavorite(song)) {
        return 'icon-favorite';
      } else {
        return 'icon-not-favorite';
      }
    },
    _isFavorite: function _isFavorite(song) {
      var index = this.favoriteList.findIndex(function (item) {
        return song.id === item.id;
      });

      return index > -1;
    },
    show: function show() {
      var _this = this;

      this.showFlag = true;

      // 延迟计算 better-scroll
      setTimeout(function () {
        _this.$refs.scrollRef.refresh();
      }, 20);

      this.scrollToCurrent(this.currentSong);
    },
    hide: function hide() {
      this.showFlag = false;
    },

    // 当前播放歌曲前面的图标
    getCurrentIcon: function getCurrentIcon(item) {
      if (this.currentSong.id === item.id) {
        return 'icon-play';
      }
      return '';
    },

    // 切歌
    selectItem: function selectItem(item, index) {
      // 随机播放
      if (this.mode === 2) {
        index = this.playlist.findIndex(function (song) {
          return song.id === item.id;
        });
      }

      this.setCurrentIndex(index);

      // 如果是暂停，切歌后自动播放
      this.setPlayingState(true);
    },

    // 切歌后滚动至第一个
    scrollToCurrent: function scrollToCurrent(current) {
      var index = this.sequenceList.findIndex(function (song) {
        return song.id === current.id;
      });

      this.$refs.scrollRef.scrollToElement(this.$refs.listRef[index], 300);
    },

    // 删除图标
    deleteOne: function deleteOne(item) {
      this.deleteSong(item);
      if (!this.playlist.length) {
        this.showFlag = false;
      }
    },
    showConfirm: function showConfirm() {
      this.$refs.confirmRef.show();
    },

    // confirm 清空对话框
    confirm: function confirm() {
      this.deleteSongList();
    },
    cancel: function cancel() {
      return;
    },

    // 改变播放模式，实质是修改 playlist
    changeMode: function changeMode() {
      var _this2 = this;

      var mode = (this.mode + 1) % 3;
      this.setMode(mode);

      var newList = null;
      if (mode === 2) {
        // 随机播放
        newList = __WEBPACK_IMPORTED_MODULE_5__common_js_myutils_js__["b" /* myArray */].shuffle(this.sequenceList);
      } else {
        // 顺序播放、单曲循环
        newList = this.sequenceList;
      }

      // 调整当前歌曲的索引
      var index = newList.findIndex(function (item) {
        return item.id === _this2.currentSong.id;
      });
      this.setCurrentIndex(index);
      this.setPlayList(newList);
    },
    showAddSong: function showAddSong() {
      this.$refs.addSongRef.show();
    }
  }),
  // 过滤器设计目的就是用于简单的文本转换
  filters: {},
  // 若要实现更复杂的数据变换，你应该使用计算属性
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['sequenceList', 'currentSong', 'mode', 'playlist', 'favoriteList']), {
    // 播放模式对应图标字体
    iconMode: function iconMode() {
      var cls = '';
      if (this.mode === 0) {
        cls = 'icon-sequence';
      } else if (this.mode === 1) {
        cls = 'icon-loop';
      } else if (this.mode === 2) {
        cls = 'icon-random';
      } else {
        cls = '';
      }
      return cls;
    },

    // 播放模式文案
    modeText: function modeText() {
      var mode = '';
      if (this.mode === 0) {
        mode = '顺序播放';
      } else if (this.mode === 1) {
        mode = '单曲循环';
      } else if (this.mode === 2) {
        mode = '随机播放';
      } else {
        mode = '';
      }
      return mode;
    }
  }),
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {}
});

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_MyScroll_MyScroll__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_MyScroll_MyScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_base_MyScroll_MyScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_MyLoading_MyLoading__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_MyLoading_MyLoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_base_MyLoading_MyLoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_MyNoResult_MyNoResult__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_MyNoResult_MyNoResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_base_MyNoResult_MyNoResult__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_search_js__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_js_SingerSongClass_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_js_SingerClass_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(53);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var TYPE_SINGER = 'singer';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MyScroll: __WEBPACK_IMPORTED_MODULE_1__components_base_MyScroll_MyScroll___default.a,
    MyLoading: __WEBPACK_IMPORTED_MODULE_2__components_base_MyLoading_MyLoading___default.a,
    MyNoResult: __WEBPACK_IMPORTED_MODULE_3__components_base_MyNoResult_MyNoResult___default.a
  },
  data: function data() {
    return {
      // 当前检索页数，用于下拉加载
      page: 1,
      // 每一页的数量
      perpage: 20,
      // 接受检索结果
      result: [],
      // 标志位。是否加载完
      hasMore: true,
      beforeScrollData: true,
      pullup: true
    };
  },

  props: {
    // 接受的检索值
    query: {
      type: String,
      default: ''
    },
    // 是否显示歌手
    zhida: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    query: function query(newVal) {
      this.search();
    }
  },
  filters: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapMutations */])({
    'setSinger': 'SET_SINGER'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(['insertSong']), {
    search: function search() {
      var _this = this;

      this.page = 1;
      this.hasMore = true;
      this.$refs.scrollRef.scrollTo(0, 0);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_search_js__["a" /* search */])(this.query, this.page, this.perpage, this.zhida).then(function (res) {
        if (res.code === 0) {
          // console.log(res.data)
          // console.log(this._formatSearch(res.data))
          _this.result = _this._formatSearch(res.data);
          _this._checkMore(res.data);
        }
      });
    },

    // 重组 res.data 数据
    _formatSearch: function _formatSearch(data) {
      var ret = [];

      if (data.zhida && data.zhida.singerid) {
        // 解构赋值
        ret.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data.zhida, { type: TYPE_SINGER }));
      }

      if (data.song) {
        ret = ret.concat(this._normalizeSongs(data.song.list));
      }

      return ret;
    },

    // 格式化歌手信息
    _normalizeSongs: function _normalizeSongs(list) {
      var ret = [];

      list.forEach(function (item) {
        if (item.songid && item.albummid) {
          ret.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_js_SingerSongClass_js__["b" /* createSingerSong */])(item));
        }
      });

      return ret;
    },

    // 获取 icon class 图标样式
    getIconCls: function getIconCls(item) {
      if (item.type === TYPE_SINGER) {
        return 'icon-mine';
      } else {
        return 'icon-music';
      }
    },
    getSingernameOrSongname: function getSingernameOrSongname(item) {
      if (item.type === TYPE_SINGER) {
        return item.singername;
      } else {
        return item.name + '-' + item.singer;
      }
    },
    scrollToEnd: function scrollToEnd() {
      var _this2 = this;

      if (!this.hasMore) {
        return;
      }

      this.page++;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_search_js__["a" /* search */])(this.query, this.page, this.perpage, this.zhida).then(function (res) {
        if (res.code === 0) {
          _this2.result = _this2.result.concat(_this2._formatSearch(res.data));
          _this2._checkMore(res.data);
        }
      });
    },

    // 路由跳转逻辑
    selectItem: function selectItem(item) {
      if (item.type === TYPE_SINGER) {
        var singer = new __WEBPACK_IMPORTED_MODULE_6__common_js_SingerClass_js__["a" /* Singer */]({
          id: item.singermid,
          name: item.singername
        });

        this.$router.push({
          path: '/search/' + singer.id
        });

        this.setSinger(singer);
      } else {
        this.insertSong(item);
      }

      this.$emit('select');
    },

    // 什么时候不上拉刷新
    _checkMore: function _checkMore(data) {
      var song = data.song;
      // 没有数据或最后一页
      if (!song.list.length || song.curnum + song.curpage * this.perpage > song.totalnum) {
        this.hasMore = false;
      }
    },

    // 滚动前触发事件
    beforeScroll: function beforeScroll() {
      this.$emit('beforeScroll');
    },

    // 给父亲用
    refresh: function refresh() {
      this.$refs.scrollRef.refresh();
    }
  }),
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {}
});

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      // 显示
      showFlag: false
    };
  },

  props: {
    // 描述性文字
    text: {
      type: String,
      default: '确认清空吗'
    },
    cancelBtnText: {
      type: String,
      default: '取消'
    },
    confirmBtnText: {
      type: String,
      default: '确定'
    }
  },
  watch: {},
  methods: {
    // 对外提供，显示对话框
    show: function show() {
      this.showFlag = true;
    },

    // 对外提供，隐藏对话框
    hide: function hide() {
      this.showFlag = false;
    },
    confirm: function confirm() {
      this.showFlag = false;
      this.$emit('confirm');
    },
    cancel: function cancel() {
      this.showFlag = false;
      this.$emit('cancel');
    }
  },
  // 过滤器设计目的就是用于简单的文本转换
  filters: {},
  // 若要实现更复杂的数据变换，你应该使用计算属性
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {}
});

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {};
  },

  props: {
    title: {
      type: String,
      default: '玩命加载中...'
    }
  },
  watch: {},
  methods: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {
    // 良好的习惯：销毁定时器
  }
});

/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {};
  },

  props: {
    title: {
      type: String,
      default: '抱歉，暂无数据'
    }
  },
  watch: {},
  filters: {},
  methods: {},
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {}
});

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BTN_WIDTH = 16;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {};
  },

  props: {
    // 当前播放进度 [0, 1]
    percent: {
      type: Number,
      default: 0
    }
  },
  watch: {
    // 播放进度
    percent: function percent(newVal) {
      // 拖动的时候不要 watch
      if (newVal >= 0 && !this.touch.init) {
        var barWidth = this.$refs.barRef.clientWidth - BTN_WIDTH;
        var offsetWidth = newVal * barWidth;

        this._move(offsetWidth);
      }
    }
  },
  methods: {
    // 点击进度条改变播放进度
    progressClick: function progressClick(e) {
      // 返回一个矩形对象，包含四个属性：left、top、right和bottom。分别表示元素各边与页面上边和左边的距离。
      var rectLeft = this.$refs.barRef.getBoundingClientRect().left;
      var offsetWidth = e.pageX - rectLeft;

      // this._move(e.offsetX) // 这样的话，点小球的时候数据不对，弃
      this._move(offsetWidth);
      this._percentChange();
    },

    // 拖动小球改变播放进度，小球滑动开始位置
    progressTouchstart: function progressTouchstart(e) {
      this.touch.init = true;
      // 开始滑动的位置
      this.touch.startX = e.touches[0].pageX;
      // 当前偏移
      this.touch.left = this.$refs.progressRef.clientWidth;
    },

    // 拖动小球改变播放进度，小球滑动过程中
    progressTouchmove: function progressTouchmove(e) {
      if (!this.touch.init) return;

      // 滑动的差值
      var deltaX = e.touches[0].pageX - this.touch.startX;
      // 进度条的差值，大于0，小于总长度
      var offsetWidth = Math.min(this.$refs.barRef.clientWidth - BTN_WIDTH, Math.max(0, this.touch.left + deltaX));

      this._move(offsetWidth);
    },

    // 拖动小球改变播放进度，小球滑动结束
    progressTouchend: function progressTouchend() {
      this.touch.init = false;
      this._percentChange();
    },

    // 进度条前进 + 小球前进
    _move: function _move(offsetWidth) {
      this.$refs.progressRef.style.width = offsetWidth + 'px';
      this.$refs.btnRef.style['webkitTransform'] = 'translate3d(' + offsetWidth + 'px, 0, 0)';
      this.$refs.btnRef.style['transform'] = 'translate3d(' + offsetWidth + 'px, 0, 0)';
    },

    // events up,改变 props percent,不能(也不应该)直接在子组件中改变 props
    _percentChange: function _percentChange() {
      var barWidth = this.$refs.barRef.clientWidth - BTN_WIDTH;
      var newPercent = this.$refs.progressRef.clientWidth / barWidth;

      this.$emit('percentChange', newPercent);
    }
  },
  computed: {},
  created: function created() {
    // 共享 touch 状态
    this.touch = {};
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {}
});

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      dasharray: Math.PI * 100
    };
  },

  props: {
    percent: {
      type: Number,
      default: 0
    },
    radius: {
      type: Number,
      default: 32
    }
  },
  watch: {},
  filters: {},
  methods: {},
  computed: {
    dashoffset: function dashoffset() {
      return (1 - this.percent) * this.dasharray;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {}
});

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_scroll__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_better_scroll__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {};
  },

  props: {
    // 传入的数据
    data: {
      type: Array,
      default: null
    },
    probeType: {
      type: Number,
      default: 1
    },
    click: {
      type: Boolean,
      default: true
    },
    // 是否监听滚动位置
    listenScroll: {
      type: Boolean,
      default: false
    },
    // 是否开启上拉刷新
    pullup: {
      type: Boolean,
      default: false
    },
    // 滚动前是否触发事件，如：滚动前让输入框失去焦点，避免滚动搜索结果时移动端键盘遮挡
    beforeScroll: {
      type: Boolean,
      default: false
    },
    // 延迟刷新
    refreshDelay: {
      type: Number,
      default: 20
    }
  },
  watch: {
    data: function data() {
      var _this = this;

      setTimeout(function () {
        _this.refresh();
      }, this.refreshDelay);
    }
  },
  methods: {
    _initScroll: function _initScroll() {
      var _this2 = this;

      if (!this.$refs.wrapper) {
        return;
      }

      this.scroll = new __WEBPACK_IMPORTED_MODULE_0_better_scroll___default.a(this.$refs.wrapper, {
        probeType: this.probeType,
        click: this.click
      });

      // 派发监听滚动位置事件
      if (this.listenScroll) {
        var me = this;
        this.scroll.on('scroll', function (pos) {
          // 向父组件传值
          me.$emit('scroll', pos);
        });
      }

      // 派发上拉刷新时间
      if (this.pullup) {
        this.scroll.on('scrollEnd', function () {
          if (_this2.scroll.y <= _this2.scroll.maxScrollY + 50) {
            // 滑动到底部了
            _this2.$emit('scrollToEnd');
          }
        });
      }

      // 滚动前是否触发事件
      if (this.beforeScroll) {
        this.scroll.on('beforeScrollStart', function () {
          _this2.$emit('beforeScroll');
        });
      }
    },
    enable: function enable() {
      this.scroll && this.scroll.enable();
    },
    disable: function disable() {
      this.scroll && this.scroll.disable();
    },
    refresh: function refresh() {
      this.scroll && this.scroll.refresh();
    },
    scrollTo: function scrollTo() {
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
    },
    scrollToElement: function scrollToElement() {
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var _this3 = this;

    setTimeout(function () {
      _this3._initScroll();
    }, 20);
  }
});

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_myutils_js__ = __webpack_require__(62);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      query: ''
    };
  },

  props: {
    placeholder: {
      type: String,
      default: '搜索歌曲、歌手'
    }
  },
  watch: {},
  filters: {},
  methods: {
    // 给父亲用的，让输入框失去焦点，避免滚动搜索结果时移动端键盘遮挡
    blur: function blur() {
      this.$refs.queryRef.blur();
    },

    // 给父亲用的，传进搜索框的值
    // this.$refs.searchBoxRef.getQuery(k)
    getQuery: function getQuery(k) {
      this.query = k;
    },
    clearQuery: function clearQuery() {
      this.query = '';
    }
  },
  computed: {},
  created: function created() {
    var _this = this;

    // 节流
    this.$watch('query', __WEBPACK_IMPORTED_MODULE_0__common_js_myutils_js__["c" /* myDOM */].debounce(function (newQuery) {
      _this.$emit('query', newQuery);
    }, 300));
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {}
});

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {};
  },

  props: {
    searches: {
      type: Array,
      default: []
    }
  },
  watch: {},
  methods: {
    selectItem: function selectItem(item) {
      this.$emit('select', item);
    },
    deleteOne: function deleteOne(item) {
      this.$emit('delete', item);
    }
  },
  // 过滤器设计目的就是用于简单的文本转换
  filters: {},
  // 若要实现更复杂的数据变换，你应该使用计算属性
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {}
});

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {};
  },

  props: {
    songs: {
      type: Array,
      default: []
    },
    // 排行奖杯图片
    rank: {
      type: Boolean,
      default: false
    }
  },
  watch: {},
  methods: {
    getDesc: function getDesc(item) {
      return item.singer + ' - ' + item.album;
    },

    // 对父亲说：我需要这些数据
    selectItem: function selectItem(item, index) {
      this.$emit('select', item, index);
    },

    // 排行奖杯图片
    getRankCls: function getRankCls(index) {
      if (index === 0) {
        return 'icon0';
      } else if (index === 1) {
        return 'icon1';
      } else if (index === 2) {
        return 'icon2';
      } else {
        return 'text';
      }
    },

    // 排行奖杯文案
    getRankTxt: function getRankTxt(index) {
      if (index > 0) {
        return index + 1;
      }
    }
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {}
});

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {};
  },

  props: {
    switches: {
      type: Array,
      default: []
    },
    currentIndex: {
      type: Number,
      default: 0
    }
  },
  watch: {},
  methods: {
    // 开关被切换了，通知父组件
    switchItem: function switchItem(index) {
      this.$emit('switch', index);
    }
  },
  // 过滤器设计目的就是用于简单的文本转换
  filters: {},
  // 若要实现更复杂的数据变换，你应该使用计算属性
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {}
});

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      showFlag: false
    };
  },

  props: {
    // 延迟关闭时间
    delay: {
      type: Number,
      default: 2000
    }
  },
  watch: {},
  methods: {
    show: function show() {
      var _this = this;

      this.showFlag = true;

      clearTimeout(this.timer);

      // delay 秒自动关闭
      this.timer = setTimeout(function () {
        _this.showFlag = false;
      }, this.delay);
    },
    hide: function hide() {
      this.showFlag = false;
    }
  },
  // 过滤器设计目的就是用于简单的文本转换
  filters: {},
  // 若要实现更复杂的数据变换，你应该使用计算属性
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {}
});

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 445:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 446:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 447:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 448:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 449:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 450:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 451:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 453:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 455:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(459)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(492),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e61ca5e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(455)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(488),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72798516",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(453)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(486),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-706338d4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(446)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(479),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b4fdaf6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(445)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(478),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b7857ca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(448)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(481),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58f4f970",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(444)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(477),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2fa2ce5a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(443)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(476),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-003f387a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 476:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "drop"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    staticClass: "my-top-tip",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hide($event)
      }
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 477:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-progress-circle"
  }, [_c('svg', {
    attrs: {
      "width": _vm.radius,
      "height": _vm.radius,
      "viewBox": "0 0 100 100",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    staticClass: "progress-background",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "50",
      "fill": "transparent"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "progress-bar",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "50",
      "fill": "transparent",
      "stroke-dasharray": _vm.dasharray,
      "stroke-dashoffset": _vm.dashoffset
    }
  })]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 478:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-tab"
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "tag": "div",
      "to": {
        name: 'recommend'
      }
    }
  }, [_c('span', {
    staticClass: "tab-link"
  }, [_vm._v("推荐")])]), _vm._v(" "), _c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "tag": "div",
      "to": {
        name: 'singer'
      }
    }
  }, [_c('span', {
    staticClass: "tab-link"
  }, [_vm._v("歌手")])]), _vm._v(" "), _c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "tag": "div",
      "to": {
        name: 'rank'
      }
    }
  }, [_c('span', {
    staticClass: "tab-link"
  }, [_vm._v("排行\n    ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "tag": "div",
      "to": {
        name: 'search'
      }
    }
  }, [_c('span', {
    staticClass: "tab-link"
  }, [_vm._v("搜索")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "list-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    staticClass: "my-playlist",
    on: {
      "click": _vm.hide
    }
  }, [_c('div', {
    staticClass: "list-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "list-header"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "icon",
    class: _vm.iconMode,
    on: {
      "click": _vm.changeMode
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.modeText))]), _vm._v(" "), _c('span', {
    staticClass: "clear",
    on: {
      "click": _vm.showConfirm
    }
  }, [_c('i', {
    staticClass: "icon-clear"
  })])])]), _vm._v(" "), _c('my-scroll', {
    ref: "scrollRef",
    staticClass: "list-content",
    attrs: {
      "data": _vm.sequenceList,
      "refreshDelay": _vm.refreshDelay
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "ul"
    }
  }, _vm._l((_vm.sequenceList), function(item, index) {
    return _c('li', {
      key: item.id,
      ref: "listRef",
      refInFor: true,
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.selectItem(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "current",
      class: _vm.getCurrentIcon(item)
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "like",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleFavoriteCls(item)
        }
      }
    }, [_c('i', {
      class: _vm.getFavoriteCls(item)
    })]), _vm._v(" "), _c('span', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteOne(item)
        }
      }
    }, [_c('i', {
      staticClass: "icon-delete"
    })])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "list-operate"
  }, [_c('div', {
    staticClass: "add",
    on: {
      "click": _vm.showAddSong
    }
  }, [_c('i', {
    staticClass: "icon-add"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("添加歌曲到队列")])])]), _vm._v(" "), _c('div', {
    staticClass: "list-close",
    on: {
      "click": _vm.hide
    }
  }, [_c('span', [_vm._v("关闭")])])], 1), _vm._v(" "), _c('my-confirm', {
    ref: "confirmRef",
    on: {
      "confirm": _vm.confirm,
      "cancel": _vm.cancel
    }
  }), _vm._v(" "), _c('my-add-song', {
    ref: "addSongRef"
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-song-list"
  }, [_c('ul', _vm._l((_vm.songs), function(item, index) {
    return _c('li', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.selectItem(item, index)
        }
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rank),
        expression: "rank"
      }],
      staticClass: "rank"
    }, [_c('span', {
      staticClass: "icon",
      class: _vm.getRankCls(index)
    }, [_vm._v(_vm._s(_vm.getRankTxt(index)))])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(_vm.getDesc(item)))])])])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 481:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "barRef",
    staticClass: "my-progress-bar",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.progressClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "bar-inner"
  }, [_c('div', {
    ref: "progressRef",
    staticClass: "progress"
  }), _vm._v(" "), _c('div', {
    ref: "btnRef",
    staticClass: "progress-btn-wrapper",
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        _vm.progressTouchstart($event)
      },
      "touchmove": function($event) {
        $event.preventDefault();
        _vm.progressTouchmove($event)
      },
      "touchend": _vm.progressTouchend
    }
  }, [_c('div', {
    staticClass: "progress-btn"
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searches.length),
      expression: "searches.length"
    }],
    staticClass: "my-search-list"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "ul"
    }
  }, _vm._l((_vm.searches), function(item) {
    return _c('li', {
      key: item,
      staticClass: "search-item",
      on: {
        "click": function($event) {
          _vm.selectItem(item)
        }
      }
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('span', {
      staticClass: "icon",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteOne(item)
        }
      }
    }, [_c('i', {
      staticClass: "icon-delete"
    })])])
  }))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "my-switches"
  }, _vm._l((_vm.switches), function(item, index) {
    return _c('li', {
      staticClass: "switch-item",
      class: {
        'active': _vm.currentIndex === index
      },
      on: {
        "click": function($event) {
          _vm.switchItem(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name) + " ")])])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "my-scroll"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-no-sesult"
  }, [_c('div', {
    staticClass: "no-result-icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "no-result-text"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playlist.length > 0),
      expression: "playlist.length > 0"
    }],
    staticClass: "my-player"
  }, [_c('transition', {
    attrs: {
      "name": "normal"
    },
    on: {
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "leave": _vm.leave,
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fullScreen),
      expression: "fullScreen"
    }],
    staticClass: "normal-player"
  }, [_c('div', {
    staticClass: "background"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentSong.img,
      "width": "100%",
      "height": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "icon-back"
  })]), _vm._v(" "), _c('p', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.name)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.singer)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "middle",
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        _vm.middleTouchstart($event)
      },
      "touchmove": function($event) {
        $event.preventDefault();
        _vm.middleTouchmove($event)
      },
      "touchend": _vm.middleTouchend
    }
  }, [_c('div', {
    ref: "middleRef",
    staticClass: "middle-l"
  }, [_c('div', {
    ref: "cdRef",
    staticClass: "cd-wrapper"
  }, [_c('div', {
    staticClass: "cd",
    class: _vm.playing ? 'play' : 'play pause'
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.currentSong.img
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "playing-lyric-wrapper"
  }, [_c('div', {
    staticClass: "playing-lyric"
  }, [_vm._v(_vm._s(_vm.playingLyric))])])]), _vm._v(" "), _c('my-scroll', {
    ref: "lyricList",
    staticClass: "middle-r",
    attrs: {
      "data": _vm.currentLyric && _vm.currentLyric.lines
    }
  }, [_c('div', {
    staticClass: "lyric-wrapper"
  }, [(_vm.currentLyric) ? _c('div', _vm._l((_vm.currentLyric.lines), function(line, index) {
    return _c('p', {
      ref: "lyricLine",
      refInFor: true,
      staticClass: "text",
      class: {
        'current': _vm.currentLyricLine === index
      }
    }, [_vm._v(_vm._s(line.txt))])
  })) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "dot-wrapper"
  }, [_c('span', {
    staticClass: "dot",
    class: {
      'active': _vm.currentDot === 'cd'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dot",
    class: {
      'active': _vm.currentDot === 'lyric'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "progress-wrapper"
  }, [_c('span', {
    staticClass: "time time-l"
  }, [_vm._v(_vm._s(_vm._f("format")(_vm.currentTime)))]), _vm._v(" "), _c('div', {
    staticClass: "progress-bar-wrapper"
  }, [_c('my-progress-bar', {
    attrs: {
      "percent": _vm.percent
    },
    on: {
      "percentChange": _vm.percentChange
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "time time-r"
  }, [_vm._v(_vm._s(_vm._f("format")(_vm.currentSong.duration)))])]), _vm._v(" "), _c('div', {
    staticClass: "operators"
  }, [_c('div', {
    staticClass: "icon i-left",
    on: {
      "click": _vm.changeMode
    }
  }, [_c('i', {
    class: _vm.iconMode
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-left",
    class: _vm.songCanplay ? '' : 'disable'
  }, [_c('i', {
    staticClass: "icon-prev",
    on: {
      "click": _vm.prevSong
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-center",
    class: _vm.songCanplay ? '' : 'disable'
  }, [_c('i', {
    class: _vm.playing ? 'icon-pause' : 'icon-play',
    on: {
      "click": _vm.togglePlaying
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-right",
    class: _vm.songCanplay ? '' : 'disable'
  }, [_c('i', {
    staticClass: "icon-next",
    on: {
      "click": _vm.nextSong
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-right"
  }, [_c('i', {
    staticClass: "icon",
    class: _vm.getFavoriteCls(_vm.currentSong),
    on: {
      "click": function($event) {
        _vm.toggleFavoriteCls(_vm.currentSong)
      }
    }
  })])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "mini"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullScreen),
      expression: "!fullScreen"
    }],
    staticClass: "mini-player",
    on: {
      "click": _vm.open
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    class: _vm.playing ? 'play' : 'play pause',
    attrs: {
      "src": _vm.currentSong.img,
      "width": "40",
      "height": "40"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "name",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.name)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.singer)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('my-progress-circle', {
    attrs: {
      "percent": _vm.percent,
      "radius": 32
    }
  }, [_c('i', {
    staticClass: "icon-mini",
    class: _vm.playing ? 'icon-pause-mini' : 'icon-play-mini',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePlaying($event)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "control",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showPlaylist($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-playlist"
  })])])]), _vm._v(" "), _c('my-playlist', {
    ref: "playlistRef"
  }), _vm._v(" "), _c('audio', {
    ref: "audioRef",
    attrs: {
      "src": _vm.currentSong.url
    },
    on: {
      "play": _vm.canplay,
      "error": _vm.error,
      "timeupdate": _vm.timeupdate,
      "ended": _vm.ended
    }
  }, [_vm._v("Your browser does not support the audio element.")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "confirm-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    staticClass: "my-confirm",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "confirm-wrapper"
  }, [_c('div', {
    staticClass: "confirm-content"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', {
    staticClass: "operate-btn left",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.confirmBtnText))]), _vm._v(" "), _c('div', {
    staticClass: "operate-btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelBtnText))])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-header"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('h1', {
    staticClass: "text"
  }, [_vm._v("Chicken Music")]), _vm._v(" "), _c('router-link', {
    staticClass: "mine",
    attrs: {
      "to": "/user",
      "tag": "div"
    }
  }, [_c('i', {
    staticClass: "icon-mine"
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('my-scroll', {
    ref: "scrollRef",
    staticClass: "my-suggest-list",
    attrs: {
      "data": _vm.result,
      "beforeScroll": _vm.beforeScrollData,
      "pullup": _vm.pullup
    },
    on: {
      "beforeScroll": _vm.beforeScroll,
      "scrollToEnd": _vm.scrollToEnd
    }
  }, [_c('ul', {
    staticClass: "suggest-list"
  }, [_vm._l((_vm.result), function(item) {
    return _c('li', {
      staticClass: "suggest-item",
      on: {
        "click": function($event) {
          _vm.selectItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('i', {
      class: _vm.getIconCls(item)
    })]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_c('p', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.getSingernameOrSongname(item))
      }
    })])])
  }), _vm._v(" "), _c('MyLoading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasMore),
      expression: "hasMore"
    }],
    attrs: {
      "title": ""
    }
  })], 2), _vm._v(" "), (!_vm.hasMore && !_vm.result.length) ? _c('div', {
    staticClass: "no-result-wrapper"
  }, [_c('my-no-result')], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-loading"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(467),
      "height": "24",
      "width": "24"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('my-header'), _vm._v(" "), _c('my-tab'), _vm._v(" "), _c('keep-alive', [_c('router-view')], 1), _vm._v(" "), _c('my-player')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 492:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    staticClass: "my-add-song",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("添加歌曲到队列")]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.hide
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "search-box-wrapper"
  }, [_c('my-search-box', {
    ref: "searchBoxRef",
    attrs: {
      "placeholder": "搜索歌曲"
    },
    on: {
      "query": _vm.onQueryChange
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.query),
      expression: "!query"
    }],
    staticClass: "shortcut"
  }, [_c('my-switches', {
    attrs: {
      "switches": _vm.switches,
      "currentIndex": _vm.currentIndex
    },
    on: {
      "switch": _vm.switchItem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "list-wrapper"
  }, [(_vm.currentIndex === 0) ? _c('my-scroll', {
    ref: "songListRef",
    staticClass: "list-scroll",
    attrs: {
      "data": _vm.playHistory
    }
  }, [_c('div', {
    staticClass: "list-inner"
  }, [_c('my-song-list', {
    attrs: {
      "songs": _vm.playHistory
    },
    on: {
      "select": _vm.selectSong
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentIndex === 1) ? _c('my-scroll', {
    ref: "searchListRef",
    staticClass: "list-scroll",
    attrs: {
      "refreshDelay": _vm.refreshDelay,
      "data": _vm.searchHistory
    }
  }, [_c('div', {
    staticClass: "list-inner"
  }, [_c('my-search-list', {
    attrs: {
      "searches": _vm.searchHistory
    },
    on: {
      "delete": _vm.delHistory,
      "select": _vm.addQuery
    }
  })], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "search-result"
  }, [_c('my-suggest-list', {
    attrs: {
      "query": _vm.query,
      "zhida": _vm.zhida
    },
    on: {
      "select": _vm.savaHis,
      "beforeScroll": _vm.blurInput
    }
  })], 1), _vm._v(" "), _c('my-top-tip', {
    ref: "topTipRef"
  }, [_c('div', {
    staticClass: "tip-title"
  }, [_c('i', {
    staticClass: "icon-ok"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("1首歌曲已经添加到播放列表")])])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-search-box"
  }, [_c('i', {
    staticClass: "icon-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    ref: "queryRef",
    staticClass: "box",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "icon-dismiss",
    on: {
      "click": _vm.clearQuery
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(484),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f01985a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return myDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return myTime; });
/* unused harmony export myNumber */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return myArray; });
/* unused harmony export myString */
/* unused harmony export myStore */
/* unused harmony export myHTTP */
/* unused harmony export myOthers */
/*
* @Author: bxm09
* @Date:   2017-08-01 10:45:26
* @Last Modified by:   bxm09
* @Last Modified time: 2017-08-09 16:57:07
*
* import { myDOM } from '@/common/js/myutils.js'
* 使用本对象中的方法时，使用 this。this.hasClass(el, className)
* 使用本库其他对象中的方法时，直接调用。myNumber.getRandom(0, i)
*/

var myDOM = {
  /**
   * 判断是否有该 class
   */
  hasClass: function hasClass(el, className) {
    var reg = new RegExp('(^|\\s)' + className + '(\\s|$)');
    return reg.test(el.className);
  },


  /**
   * 添加 class
   */
  addClass: function addClass(el, className) {
    if (this.hasClass(el, className)) {
      return;
    }
    var newClass = el.className.split(' ');
    newClass.push(className);
    el.className = newClass.join(' ');
  },


  /**
   * 获取/设置 自定义属性 data-${name}=val
   * 如果传入了 val 就设置自定义属性 `data-${name}` 的值为 val
   * 如果没有传入了 val 就获取自定义属性 `data-${name}` 的值
   */
  customAttribute: function customAttribute(el, name, val) {
    if (val) {
      return el.setAttribute('data-' + name, val);
    } else {
      return el.getAttribute('data-' + name);
    }
  },


  /**
   * 去抖（节流）
   * 有一些浏览器事件可以很快地在短时间内多次触发，
   * 例如调整窗口大小、向下滚动页面、搜索框节流等。
   * 如果你将事件监听器绑定到窗口滚动事件，并且用户不断快速地向下滚动页面，
   * 则你的事件可能在1秒内触发数千次。这可能会导致一些严重的性能问题。
   * 解决这个问题的一种方法是去抖，通过限制再次调用函数之前必须经过的时间。
   * 因此，去抖的正确实现是将几个函数调用组合成一个，并且在经过一段时间后仅执行一次。
   *
   * document.addEventListener('scroll', debounce(function () {
   *   console.log('hello');
   * }, 1000));
   *
   * @param  {Function} fn    要节流的函数
   * @param  {number}   delay 延迟毫秒数
   */
  debounce: function debounce(fn, delay) {
    var timer = null;

    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(function () {
        fn.apply(_this, args);
      }, delay);
    };
  }
};

var myTime = {
  /**
   * 格式化时间戳(分:秒)
   * 61 -> 01:01
   */
  format: function format(timestamp) {
    timestamp = Math.floor(timestamp);

    var minute = Math.floor(timestamp / 60).toString().padStart(2, '0');
    var second = (timestamp % 60).toString().padStart(2, '0');
    return minute + ':' + second;
  }
};

var myNumber = {
  /**
   * 返回一个 [min, max] 之间的随机整数
   * @param  {number} min 下界
   * @param  {number} max 上界
   */
  getRandom: function getRandom(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
};

var myArray = {
  /**
   * 克隆数组
   * @param  {array} arr 原数组
   * @return {array}     新数组
   */
  cloneArr: function cloneArr(arr) {
    // 从第一个字符就开始 copy
    // slice(start,end) 方法可从已有的数组中返回选定的元素。
    return arr.slice(0);
  },


  /**
   * 洗牌函数
   * @param  {Array} arr 原数组
   * @param  {boolean} flag 是否改变原数组，默认不改变
   * @return {Array}     新数组
   */
  shuffle: function shuffle(arr) {
    var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var newArr = [];
    flag ? newArr = arr : newArr = this.cloneArr(arr);

    for (var i = 0; i < newArr.length; i++) {
      var j = myNumber.getRandom(0, i);
      var temp = newArr[i];
      newArr[i] = newArr[j];
      newArr[j] = temp;
    }
    return newArr;
  },


  /**
   * 随机获取数组成员
   * @param  {array} arr 传入数组
   * @return {[type]}    一个随机成员
   */
  randomMember: function randomMember(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }
};

var myString = {};

var myStore = {
  // https://github.com/ustbhuangyi/storage
  // https://github.com/jaywcjlove/store.js
};

var myHTTP = {};

var myOthers = {};

/***/ })

},[196]);


// WEBPACK FOOTER //
// static/js/app.925b793d93c2ec640f9b.js